import getInstanceAxios from './RequestGlobalConfig';

export default getInstanceAxios(process.env.REACT_APP_BASE_API_AUTHOR);
export const listMenu = getInstanceAxios(process.env.REACT_APP_GET_LIST_MENU)
